import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { UserSessionService } from 'src/app/services/usersession.service';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from 'src/app/services/utility.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangepasswordComponent } from '../changepassword/changepassword.component';
import { UserService } from 'src/app/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { RoleType } from 'src/enum/roletype';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { debug } from 'console';
import { DriverService } from 'src/app/services/driver.service';
import { AdministrativeMappingService } from 'src/app/services/administrative-mapping.service';
import * as moment from 'moment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  form: FormGroup;
  username: string;
  clientList: any[];
  client = [];
  languageType: any;
  Languages: any[];
  dropdownconfig = {};
  // tslint:disable-next-line: variable-name
  userdata: any;
  userImg: any;
  userId: number;
  emailId: any;
  regionList: any[];
  divisionList: any[];
  subdivisionList: any[];
  blockList: any[];
  regionId: any;
  divisionId: any;
  subdivisionId: any;
  filterregionList: any[];
  filterdivisionList: any[];
  filtersubdivision: any[];
  filterblockList: any[];
  roleName: any;
  roleId: number;
  accessall: boolean;
  accessExEng: boolean;
  accessSpeEng: boolean;
  public RoleEnumType = RoleType;
  notificationList: any[];
  active: boolean;
  subDivision: any;
  subDivisionName: any;
  companyName: any;
  manufacturerRefNo: any;
  isBlocklevel: boolean = false;
  pageurl: any;
  financialYearList: any[] = [];
  filterFinancialYearList: any[] = [];
  selectedFinYearId: any;
  currentYear: any;
  currentMonth: any;
  Today: Date;


  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private userSessionService: UserSessionService,
    private utilityService: UtilityService,
    private authService: AuthenticationService,
    private navigationService: NavigationService,
    private router: Router,
    public dialog: MatDialog,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private subdivisionService: SubDivisionService,
    private driverService: DriverService,
    private dashboardService: DashboardService,
    private administrativeMappingService: AdministrativeMappingService,

  ) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|ta|tl|de|af/) ? browserLang : 'en');
    this.languageType = userSessionService.getLanguageType();
    this.userId = userSessionService.userId();
    this.emailId = userSessionService.getEmail();
    this.regionList = [];
    this.divisionList = [];
    this.subdivisionList = [];
    this.filterregionList = [];
    this.filterdivisionList = [];
    this.filtersubdivision = [];

    this.roleId = this.userSessionService.roleId();
    this.accessall = this.roleId === this.RoleEnumType.Root
      || this.roleId === this.RoleEnumType.SuperAdmin
      || this.roleId === this.RoleEnumType.ChiefEngineer
      || this.roleId === this.RoleEnumType.SeniorEngineer || this.roleId === this.RoleEnumType.WSAE
      || this.roleId === this.RoleEnumType.WSAEE;
    this.accessExEng = this.roleId === this.RoleEnumType.ExecutiveEngineer;
    this.accessSpeEng = this.roleId === this.RoleEnumType.SuperintendEngineer;
  }

  ngOnInit(): void {
    this.username = this.userSessionService.getUserName();
    this.roleName = this.userSessionService.roleName();
    this.subDivision = this.userSessionService.getSubDivisionId();
    this.dropdownconfig = {
      search: true,
      placeholder: 'Select Client',
      height: '250px',
    }
    this.initializeValidators();
    this.getfinancialyear(true);
    this.pageurl = this.router.url;
    if (this.pageurl === '/vehicles') {
      this.isBlocklevel = true;
    } else {
      this.isBlocklevel = false;

    }
    this.getLanguage();
    this.getUserImg(true);
    // this.getLookupRegion(true);

    // Preserve existing filter values from session on page refresh.
    // Only reset to 0 if no prior value is stored.
    const storedRegion = this.userSessionService.getFilterregionId() ?? 0;
    const storedDivision = this.userSessionService.getFilterDivisionId() ?? 0;
    const storedSubDivision = this.userSessionService.getFilterSubDivisionId() ?? 0;
    const storedBlock = this.userSessionService.getFilterBlockId() ?? 0;

    this.updateRegion(storedRegion);
    this.updateDivision(storedDivision);
    this.updateSubDivision(storedSubDivision);
    this.updateBlock(storedBlock);
    // this.getNotification();
    // this.getNotificationBink();

    // if (this.roleId >= 5 && this.roleId <= 12) {
    //   this.form.controls['financialYearId'].disable();
    // }

    this.Today = new Date();
    this.currentYear = this.Today.getFullYear();
    this.currentMonth = (this.Today.getMonth() + 1).toString();
    if (this.currentMonth == 0) {
      this.currentMonth = "12"
    }
    var curMonth = parseInt(this.currentMonth);
    if (curMonth > 3) {
      this.currentYear = this.currentYear + 1;
    }
  }

  refresh() {
    this.form.controls['regionid'].setValue(0);
    this.form.controls['divisionId'].setValue(0);
    this.form.controls['subdivisionId'].setValue(0);
    this.form.controls['blockId'].setValue(0);
    this.divisionList = [];
    this.filterdivisionList = [];
    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.blockList = [];
    this.filterblockList = [];

    this.updateRegion(0);
    this.updateDivision(0);
    this.updateSubDivision(0);
    this.updateBlock(0);

    this.getfinancialyear(true);
    this.userSessionService.emitRefresh();

    const baseUrl = this.router.url.split('?')[0];
    this.router.navigateByUrl(baseUrl + '?data=' + new Date().getTime(), { replaceUrl: true });
  }

  exengrefresh() {
    this.form.controls['subdivisionId'].setValue(0);
    this.form.controls['blockId'].setValue(0);
    this.blockList = [];
    this.filterblockList = [];
    this.getfinancialyear(true);
    this.updateSubDivision(0);
    this.updateBlock(0);

    const baseUrl = this.router.url.split('?')[0];
    this.router.navigateByUrl(baseUrl + '?data=' + new Date().getTime(), { replaceUrl: true });
  }

  sperefresh() {
    this.getfinancialyear(true);
    this.form.controls['divisionId'].setValue(0);
    this.updateDivision(0);
    this.form.controls['subdivisionId'].setValue(0);
    this.updateSubDivision(0);
    this.form.controls['blockId'].setValue(0);
    this.updateBlock(0);

    const baseUrl = this.router.url.split('?')[0];
    this.router.navigateByUrl(baseUrl + '?data=' + new Date().getTime(), { replaceUrl: true });
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      regionid: [0, [Validators.required]],
      divisionId: [0, [Validators.required]],
      subdivisionId: [0, [Validators.required]],
      blockId: [0, [Validators.required]],
      financialYearId: [0]


    });
  }

  getfinancialyear(refresh: boolean) {

    this.regionService.getFinYear(refresh).subscribe(result => {

      if (result) {

        this.financialYearList = result;

        this.filterFinancialYearList = [];

        // this.filterFinancialYearList.push({
        //   key: 0,
        //   value: "All",
        //   startYear: 0,
        //   endYear: 0
        // });

        this.financialYearList.forEach(element => {
          this.filterFinancialYearList.push(element);
        });

        const today = new Date();

        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;

        let selectedYear: any;

        // April to March FY
        if (currentMonth >= 4) {

          selectedYear = this.financialYearList.find(x =>
            Number(x.startYear) === currentYear &&
            Number(x.endYear) === currentYear + 1
          );

        } else {

          selectedYear = this.financialYearList.find(x =>
            Number(x.startYear) === currentYear - 1 &&
            Number(x.endYear) === currentYear
          );

        }

        if (!selectedYear && this.financialYearList.length > 0) {
          selectedYear = this.financialYearList[this.financialYearList.length - 1];
        }
        // Patch current FY
        if (selectedYear) {

          this.selectedFinYearId = selectedYear.key;

          this.form.controls['financialYearId']
            .setValue(selectedYear.key);

          this.userSessionService.setActualCurrentFinancialYearId(selectedYear.key);
          this.userSessionService.emitFinancialYearChange(selectedYear.key);

        }

        this.getLookupRegion(true);
      }
    });
  }
  finYearChange() {
    this.selectedFinYearId =
      this.form.value.financialYearId;

    this.userSessionService.emitFinancialYearChange(this.selectedFinYearId);

    this.form.controls["regionid"].setValue(0);
    this.form.controls["divisionId"].setValue(0);
    this.form.controls["subdivisionId"].setValue(0);
    this.form.controls['blockId'].setValue(0);

    this.regionList = [];
    this.filterregionList = [];
    this.divisionList = [];
    this.filterdivisionList = [];
    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.blockList = [];
    this.filterblockList = [];

    this.regionId = 0;
    this.divisionId = 0;
    this.subdivisionId = 0;

    this.updateRegion(0);
    this.updateDivision(0);
    this.updateSubDivision(0);
    this.updateBlock(0);


    this.getLookupRegion(true);
  }

  // getRefDate(): string {

  //   const selectedId = this.form.value.financialYearId;

  //   const finYear = this.financialYearList.find(
  //     y => Number(y.key) === Number(selectedId)
  //   );

  //   if (!finYear || Number(finYear.startYear) === 0) {
  //     return moment().format('YYYY-MM-DD');
  //   }

  //   // const today = new Date();

  //   // const currentFY =
  //   //   today.getMonth() + 1 >= 4
  //   //     ? today.getFullYear()
  //   //     : today.getFullYear() - 1;

  //   // // Current FY => today's date
  //   // if (Number(finYear.startYear) === currentFY) {
  //   //   return moment().format('YYYY-MM-DD');
  //   // }
  //   //  return moment().format('YYYY-MM-DD');

  //   return `${finYear.startYear}-05-02`;
  // }


  getUserImg(refresh: boolean) {
    this.userService.getById(this.userId, refresh).subscribe(result => {
      this.userdata = result;
      this.userImg = result.userPhoto;
      this.companyName = result.companyName;
      this.manufacturerRefNo = result.manufacturerRefNo;
    });
  }

  getLookupRegion(refresh: boolean) {
    const financialyear = this.form.value.financialYearId ?? 0;
    this.administrativeMappingService.getRegions(financialyear, refresh).subscribe(result => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        this.filterregionList = this.regionList.slice();
        const regionLength = this.regionList.length;

        // Restore previously selected region from session, or auto-select if only one option
        const storedRegion = this.userSessionService.getFilterregionId() ?? 0;
        if (storedRegion && storedRegion !== 0 && this.regionList.some(r => r.key === storedRegion)) {
          this.form.controls['regionid'].setValue(storedRegion);
          this.getLookupDivision(storedRegion);
        } else if (regionLength === 1) {
          this.form.controls['regionid'].setValue(this.regionList[0].key);
          this.getLookupDivision(this.form.value.regionid);
        }
      }
    })
  }

  regionChange(event) {
    this.getLookupDivision(this.form.value.regionid);
    this.form.controls['divisionId'].setValue(0);
    this.form.controls['subdivisionId'].setValue(0);
    this.form.controls['blockId'].setValue(0);

    this.subdivisionList = [];
    this.filtersubdivision = [];
    this.blockList = [];
    this.filterblockList = [];
    this.updateRegion(this.form.value.regionid);
    this.updateDivision(0);
    this.updateSubDivision(0);
    this.updateBlock(0);
  }
  updateParam() {
    const urls = this.router.url.split('?');
    const url2 = this.router.url.split('/');
    if (url2.length === 2) {
      this.router.navigate([urls[0]], {
        queryParams: { data: new Date().getTime() }
      });
    }
  }

  getLookupDivision(id) {
    const financialyear = this.form.value.financialYearId ?? 0;
    this.administrativeMappingService.getDivisions(id, financialyear, true).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterdivisionList = [];
        this.divisionList = result;
        this.filterdivisionList = this.divisionList.slice();
        const divisionLength = this.divisionList.length;

        // Restore previously selected division from session, or auto-select if only one option
        const storedDivision = this.userSessionService.getFilterDivisionId() ?? 0;
        if (storedDivision && storedDivision !== 0 && this.divisionList.some(d => d.key === storedDivision)) {
          this.form.controls['divisionId'].setValue(storedDivision);
          this.updateDivision(storedDivision);
          this.getLookupSubDivision(storedDivision);
        } else if (divisionLength === 1) {
          this.form.controls['divisionId'].setValue(this.divisionList[0].key);
          this.getLookupSubDivision(this.form.value.divisionId);
          this.updateDivision(this.form.value.divisionId);
          this.updateSubDivision(0);
        } else {
          this.updateParam();
        }
      } else {
        this.updateParam();
      }
    })
  }

  divisionChange() {
    this.getLookupSubDivision(this.form.value.divisionId);
    this.form.controls['subdivisionId'].setValue(0);
    this.updateDivision(this.form.value.divisionId);
    this.updateSubDivision(0);

    this.blockList = [];
    this.filterblockList = [];
    this.router.navigate([this.router.url.split('?')[0]], {
      queryParams: { data: new Date().getTime() }
    });
  }

  getLookupSubDivision(id) {
    const financialyear = this.form.value.financialYearId ?? 0;
    this.administrativeMappingService.getSubDivisions(id, financialyear, true).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filtersubdivision = [];
        this.subdivisionList = result;
        this.filtersubdivision = this.subdivisionList.slice();
        const subdivisionLength = this.subdivisionList?.length;

        // Restore previously selected subdivision from session, or auto-select if only one option
        const storedSubDivision = this.userSessionService.getFilterSubDivisionId() ?? 0;
        if (storedSubDivision && storedSubDivision !== 0 && this.subdivisionList.some(s => s.key === storedSubDivision)) {
          this.form.controls['subdivisionId'].setValue(storedSubDivision);
          this.updateSubDivision(storedSubDivision);
          this.subDivisionName = this.subdivisionList.find(s => s.key === storedSubDivision)?.value;
          this.getLookupBlock(storedSubDivision);
        } else if (subdivisionLength === 1) {
          this.form.controls['subdivisionId'].setValue(this.subdivisionList[0].key);
          this.getLookupBlock(this.form.value.subdivisionId);
          this.updateSubDivision(this.form.value.subdivisionId);
          this.subDivisionName = this.subdivisionList[0].value;
        }
        this.updateParam();
      }
    })
  }

  subdivisionChange() {
    this.getLookupBlock(this.form.value.subdivisionId);

    localStorage.setItem('subdivisionid', this.form.value.subdivisionId);
    this.updateSubDivision(this.form.value.subdivisionId);
    this.updateBlock(0);
    this.router.navigate([this.router.url.split('?')[0]], {
      queryParams: { data: new Date().getTime() }
    });
    this.userSessionService.emitSubDivisionChange();
  }

  getLookupBlock(id) {
    this.driverService.getBlocklist(id, true).subscribe(result => {
      if (result) {
        this.blockList = [];
        this.filterblockList = [];
        this.blockList = result;
        this.filterblockList = this.blockList.slice();
        const blockLength = this.blockList.length;

        const storedBlock = this.userSessionService.getFilterBlockId() ?? 0;
        if (storedBlock && storedBlock !== 0 && this.blockList.some(s => s.key === storedBlock)) {
          this.form.controls['blockId'].setValue(storedBlock);
          this.updateBlock(storedBlock);
          this.subDivisionName = this.blockList.find(s => s.key === storedBlock)?.value;
        } else if (blockLength === 1) {
          this.form.controls['blockId'].setValue(this.blockList[0].key);
          this.updateBlock(this.form.value.blockId);
          // this.subDivisionName = this.subdivisionList[0].value
        }
        this.updateParam();
      }
    })
  }


  blockChange() {
    localStorage.setItem('blockId', this.form.value.blockId);
    this.updateBlock(this.form.value.blockId);
    this.router.navigate([this.router.url.split('?')[0]], {
      queryParams: { data: new Date().getTime() }
    });
    // this.router.navigate([this.router.url])
    this.userSessionService.emitBlockChange();

  }

  updateRegion(regionId) {
    const obj = this.userSessionService.load();
    obj.filterregionId = regionId;
    this.userSessionService.setdecodedToken(obj);
  }

  updateDivision(divisionId) {
    const obj = this.userSessionService.load();
    obj.filterdivisionId = divisionId;
    this.userSessionService.setdecodedToken(obj);
  }

  updateSubDivision(subDivisionId) {
    const obj = this.userSessionService.load();
    obj.filtersubdivisionId = subDivisionId;
    this.userSessionService.setdecodedToken(obj);
  }

  updateBlock(blockId) {
    const obj = this.userSessionService.load();
    obj.filterblockId = blockId;
    this.userSessionService.setdecodedToken(obj);
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e) {
    e.preventDefault();
    const title = this.translate.instant('LogoutConfirmation');
    const txt = this.translate.instant('Youwanttologout');
    const Yes = this.translate.instant('Yes');
    const No = this.translate.instant('No');
    swal.fire({
      title,
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.userService.logout(true).subscribe(res => {
          this.navigationService.goToLogin();
          this.authService.logOut();
        });
      }
    })
  }

  getLanguage() {
    this.utilityService.getLanguageTypeLookup(true).subscribe(res => {
      if (res) {
        this.Languages = [];
        this.Languages = res;
        switch (this.languageType) {
          case 1:
            this.translate.use('en');
            break;
          case 2:
            this.translate.use('ta');
            break;
          case 3:
            this.translate.use('tl');
            break;
          default:
            this.translate.use('en');
            break;
        }
      }
    });
  }

  changeClient(item) {
    if (item.value) {
      this.updateClientName(item.value.description);
      this.updateClientId(item.value.id);
      this.clientList = _.orderBy(this.clientList, ['description'], ['asc']);
      if (this.router.url === '/dashboard') {
        this.router.navigate(['dashboard']);
      } else {
        this.router.navigate(['dashboard']);
      }
    }
  }

  initializeDefaultClient(item) {
    this.updateClientId(item.id);
    // this.notifyService.emitChange4(item.id);
    this.updateClientName(item.description);
  }

  updateClientId(clientId) {
    const obj = this.userSessionService.load();
    obj.currentClientId = clientId;
    this.userSessionService.setdecodedToken(obj);
  }

  updateClientName(clientName) {
    const obj = this.userSessionService.load();
    obj.currentClientName = clientName;
    this.userSessionService.setdecodedToken(obj);
  }

  openMyProfile() {
    // const myuserId = this.userSessionService.userId();
    // Second param is actionInfo given as 0 to open user profile in Edit mode (not in view mode)
    this.navigationService.goToProfile(0);
  }

  openChangePasswordDialog() {
    const dialogRef = this.dialog.open(ChangepasswordComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog'

    })
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.authService.logOut();
        this.navigationService.goToLogin();
      }
    });

  }


  getNotification() {
    this.dashboardService.getNotification(true).subscribe(result => {
      if (result) {
        this.notificationList = result;
      }
    })
  }

  // getNotificationBink() {
  //   this.dashboardService.getNotificationBlink(true).subscribe(result => {
  //     if (result) {
  //       this.active = result;
  //     }
  //   });
  // }

  // onDownloadAPK(){

  // }
}
